// web_components/wcPromo/wcPromo_Renderer.ts

/**
 * Generates the HTML for the wc-promo component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-promo${variables.galleryStyle === 'true' ? ' wc-promo--gallery' : ''}">
			<div class="wc-promo__container">
				<h2 class="wc-promo__heading ${variables.bgColor ? ' wc-promo--padded' : ''}">${variables.heading}</h2>
				<div class="wc-promo__items">
					<div class="${variables.enableSlider === 'true' ? `slider__track show-buffer-buttons` : `wc-promo__items-grid`}">
						${
							variables.item1_image
								? `
								<div class="wc-promo__item slider__item">
									<div ${variables.itemShrink === 'true' ? 'class="wc-promo__item-shrink"' : ''}>
										<div>
											${variables.item1_link ? `<a class="wc-promo__item-image-wrapper" href="${variables.item1_link}">` : ''}
												<img class="wc-promo__item-image" src="${variables.item1_image}" alt="${variables.item1_image_alt}">
											${variables.item1_link ? `</a>` : ''}
										</div>
										<div>
											<h2 class="wc-promo__item-heading">${variables.galleryStyle === 'true' ? '' : variables.item1_heading}</h2>
											<p class="wc-promo__item-copy">${variables.galleryStyle === 'true' ? '' : variables.item1_copy}</p>
											<a href="${variables.item1_link}" class="wc-promo__item-link">${variables.item1_link_text}</a>
										</div>
									</div>
								</div>`
								: ''
						}
						${
							variables.item2_image
								? `
						<div class="wc-promo__item slider__item">
							<div ${variables.itemShrink === 'true' ? 'class="wc-promo__item-shrink"' : ''}>
								<div>
									${variables.item2_link ? `<a class="wc-promo__item-image-wrapper" href="${variables.item2_link}">` : ''}
										<img class="wc-promo__item-image" src="${variables.item2_image}" alt="${variables.item2_image_alt}">
									${variables.item2_link ? `</a>` : ''}
								</div>
								<div>
									<h2 class="wc-promo__item-heading">${variables.galleryStyle === 'true' ? '' : variables.item2_heading}</h2>
									<p class="wc-promo__item-copy">${variables.galleryStyle === 'true' ? '' : variables.item2_copy}</p>
									<a href="${variables.item2_link}" class="wc-promo__item-link">${variables.item2_link_text}</a>
								</div>
							</div>
						</div>`
								: ''
						}
						${
							variables.item3_image
								? `
						<div class="wc-promo__item slider__item">
							<div ${variables.itemShrink === 'true' ? 'class="wc-promo__item-shrink"' : ''}>
								<div>
									${variables.item3_link ? `<a class="wc-promo__item-image-wrapper" href="${variables.item3_link}">` : ''}
										<img class="wc-promo__item-image" src="${variables.item3_image}" alt="${variables.item3_image_alt}">
									${variables.item3_link ? `</a>` : ''}
								</div>
								<div>
									<h2 class="wc-promo__item-heading">${variables.galleryStyle === 'true' ? '' : variables.item3_heading}</h2>
									<p class="wc-promo__item-copy">${variables.galleryStyle === 'true' ? '' : variables.item3_copy}</p>
									<a href="${variables.item3_link}" class="wc-promo__item-link">${variables.item3_link_text}</a>
								</div>
							</div>
						</div>`
								: ''
						}
						${
							variables.item4_image && variables.galleryStyle === 'false'
								? `
										<div class="wc-promo__item slider__item">
											<div ${variables.itemShrink === 'true' ? 'class="wc-promo__item-shrink"' : ''}>
												<div>
													${variables.item4_link ? `<a class="wc-promo__item-image-wrapper" href="${variables.item4_link}">` : ''}
														<img class="wc-promo__item-image" src="${variables.item4_image}" alt="${variables.item4_image_alt}">
													${variables.item4_link ? `</a>` : ''}
												</div>
												<div>
													<h2 class="wc-promo__item-heading">${variables.item4_heading}</h2>
													<p class="wc-promo__item-copy">${variables.item4_copy}</p>
													<a href="${variables.item4_link}" class="wc-promo__item-link">${variables.item4_link_text}</a>
												</div>
											</div>
										</div>
									`
								: ''
						}
					</div>
				</div>
			</div>
		</section>
    `;
}
